import { render } from "./projects.vue?vue&type=template&id=91b4e862"
import script from "./projects.ts?vue&type=script&lang=js"
export * from "./projects.ts?vue&type=script&lang=js"

import exportComponent from "I:\\Dev\\Projects\\LabManagement\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__